import Splide from "@splidejs/splide";

const constructionSlider = document.querySelectorAll(".construction__slider");

// スライダーの設定
const constructionSliderOptions = {
  type: "loop",
  rewind: true,
  rewindSpeed: 1000,
  interval: 3000,
  pauseOnHover: false,
  gap: "1rem",
};

for (const slider of constructionSlider) {
  new Splide(slider, constructionSliderOptions).mount();
}

// スクロールヒント
const historyTable = document.querySelector(".history__table");
const scrollHint = document.querySelector(".scroll-hint");

historyTable.addEventListener("touchstart", (event) => {
  event.stopPropagation()
  scrollHint.classList.add("hide");
})

